import { SiCivicrm } from "react-icons/si";
import { TfiReload } from "react-icons/tfi";
import { LiaFileInvoiceDollarSolid, LiaTruckSolid } from "react-icons/lia";
import { TbInvoice } from "react-icons/tb";
import { TfiMoney } from "react-icons/tfi";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/sales/home'
  },
  {
    titleKey: "sidebar.quotes",
    title: "Quotes",
    icon: <TbInvoice />,
    link: '/sales/quotes',
    permission: 'sales.quotes.view'
  },
  {
    titleKey: "sidebar.invoices",
    title: "Invoices",
    icon: <LiaFileInvoiceDollarSolid />,
    link: '/sales/invoices',
    permission: 'sales.invoices.view'
  },
  {
    titleKey: "sidebar.deliveryNotes",
    title: "Delivery Notes",
    icon: <LiaTruckSolid />,
    link: '/sales/delivery-notes',
    permission: 'sales.delivery_notes.view'
  },
  {
    titleKey: "sidebar.recurringInvoices",
    title: "Recurring Invoices",
    icon: <TfiReload />,
    link: '/sales/recurring-invoices',
    permission: 'sales.recurring_invoices.view'
  },
  {
    titleKey: "sidebar.paymentsReceived",
    title: "Payments Received",
    icon: <TfiMoney />,
    link: '/sales/payments',
    permission: 'sales.payments.view'
  }
];

export default sidebar;
